"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoopAxiosApiClient = exports.NOOP_API_URL = void 0;
const api_client_1 = require("./api-client");
exports.NOOP_API_URL = "http://localhost.nothing";
/**
 * NoopAxiosApiClient is a minimal client for unit testing.
 * Can be used via `providers: [{provide: AxiosApiClient, useClass: NoopAxiosApiClient}]`
 */
class NoopAxiosApiClient extends api_client_1.AxiosApiClient {
    constructor() {
        super({ apiUrl: exports.NOOP_API_URL });
    }
}
exports.NoopAxiosApiClient = NoopAxiosApiClient;
